import { useSelector, useDispatch } from "react-redux";

import { showOrHideModal } from "redux/slices/modals";

function useAddProductCompatibilityModal(props) {
  const addProductCompatibilityModalIsOpen = useSelector(
    (state) => state.modals.addProductCompatibilityModalIsOpen
  );
  const dispatch = useDispatch();

  const showAddProductCompatibilityModal = (props) => {
    dispatch(
      showOrHideModal({
        addProductCompatibilityModalIsOpen: true,
        addProductCompatibilityModalProps: props ? props : null,
      })
    );
  };

  const hideAddProductCompatibilityModal = () => {
    dispatch(
      showOrHideModal({
        addProductCompatibilityModalIsOpen: false,
        addProductCompatibilityModalProps: null,
      })
    );
  };

  return {
    addProductCompatibilityModalIsOpen,
    showAddProductCompatibilityModal,
    hideAddProductCompatibilityModal,
  };
}

export default useAddProductCompatibilityModal;
